export default class StringUtilities {
  static escapeSpecialHtmlCharacters(text) {
    if (text) {
      return text
       .replace(/&/g, '&amp;')
       .replace(/</g, '&lt;')
       .replace(/>/g, '&gt;')
       .replace(/"/g, '&quot;')
       .replace(/'/g, '&#039;')
       .replace(/\^/g, '&#94;');
    }
    return '';
  }

  static revertSpecialHtmlCharacters(text) {
    if (text) {
      return text
       .replace(/&amp;/g, '&')
       .replace(/&lt;/g, '<')
       .replace(/&gt;/g, '>')
       .replace(/&quot;/g, '"')
       .replace(/&#039;/g, '\'')
       .replace(/&#94;/g, '^');
    }
    return '';
  }

  /**
   * Convert all '/'s to '\' in a phrase
   * eg: 2020/11/20 -> 2020\11\20
   * @param {String} text string to be processed
   * @returns {String} processed string
   */
  static convertAllForwardSlashesToBack = (text) => text ? text.replace(/\//g, '\\') : '';

  /**
   * Remove the unit from a string from the tail
   * eg: 120cm -> 120
   * @param {String} value value with unit
   * @param {String} unit unit
   * @returns 
   */
  static removeTrailUnits = (value, unit = '"') => {
    if (!unit || !value || value.length <= unit.length || !value.includes(unit)) {
      return value;
    }
    return value.slice(0, value.length - unit.length).trim();
  }
}
